import Box from '@mui/material/Box';
import type { CSSProperties } from 'react';

interface Props {
  size?: number;
  color?: string;
  style?: CSSProperties;
  variant?: string;
}

export default function ReportFileSvgIcon({ size = 20, color = 'currentColor', style }: Props) {
  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: size,
        height: size,
        color,
        '& svg': {
          width: '100%',
          height: '100%',
          display: 'block'
        }
      }}
      style={style}
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
        <defs>
          <clipPath clipPathUnits="userSpaceOnUse" id="reportFileClipPath">
            <path d="M 0,24 H 24 V 0 H 0 Z" />
          </clipPath>
        </defs>

        <g transform="matrix(1.3333333,0,0,-1.3333333,0,32)">
          <g transform="translate(16,10)">
            <path d="M 0,0 H -8" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </g>

          <g transform="translate(13,6)">
            <path d="M 0,0 H -5" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </g>

          <g clipPath="url(#reportFileClipPath)">
            <g transform="translate(11.5146,23)">
              <path
                d="M 0,0 C 1.592,0 3.117,-0.632 4.243,-1.757 L 7.728,-5.243 C 8.854,-6.368 9.485,-7.894 9.485,-9.485 V -18 c 0,-2.209 -1.791,-4 -4,-4 h -10 c -2.209,0 -4,1.791 -4,4 v 14 c 0,2.209 1.791,4 4,4 z"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </g>

            <g transform="translate(13,22)">
              <path
                d="M 0,0 V -5 C 0,-6.104 0.896,-7 2,-7 H 7"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </g>
          </g>
        </g>
      </svg>
    </Box>
  );
}
